module.exports = __webpack_public_path__ + "static/media/Tomorrow-Regular.a03efb76.ttf";